import React from 'react';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './Synopsis.scss';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';

class Synopsis extends React.PureComponent {
  constructor(props) {
    super(props);
    this.doReportSize = true;
    this.state = {
      expanded: !!props.disableCollapse,
      visible: false,
    };
  }

  isReadMoreRqrd = e => {
    const isReadMore =
      e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth;
    return isReadMore;
  };

  handleLoad = () => {
    if (!this.props.disableCollapse) {
      const flag = this.isReadMoreRqrd(this.synopsis);
      this.setState({ visible: flag });
    }
  };

  componentDidUpdate() {
    // console.log(
    //   'componentDidMount isReadMoreRqrd - ',
    //   flag,
    //   this.state.visible,
    //   this.synopsis,
    // );
    // if (this.doReportSize) {
    //   this.doReportSize = false;
    // }
  }

  refCallback = e => {
    if (!this.props.disableCollapse) {
      setTimeout(() => {
        if (e) {
          const ovrflow =
            e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth;
          this.setState({ visible: ovrflow });
        }
      }, 5000);
    }
  };

  render() {
    const { expanded } = this.state;
    const { customClass } = this.props;
    const toggledClass = expanded ? `${s.expanded}` : `${s.collapsed}`;

    const isSynopsisPresent =
      this.props.synopsis && this.props.synopsis.length > 0;

    if (!isSynopsisPresent) {
      return null;
    }
    return (
      isSynopsisPresent && (
        <InViewObserver>
          <div
            className={`${s.synopsis} ${
              customClass ? s[customClass] : ''
            } id-r-synopsis`}
          >
            <div className={s.doubledot_heading}>
              {/* <span>Synopsis</span> */}
              <div className={`${s.syncontent}`}>
                <div
                  className={`${s.innercont} ${toggledClass}`}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: `${this.props.synopsis}`,
                  }}
                  data-ua-type="1"
                  data-sp-pd-click="stpPgtnAndPrvntDefault(event)"
                  onClick={event => {
                    window.stpPgtnAndPrvntDefault(event);
                  }}
                  ref={this.refCallback}
                />
                {this.state.visible && (
                  <span
                    className={`${s.readMore} ${expanded ? s.readLess : ''}`}
                    onClick={() => {
                      analyticsWrapper('ga4', {
                        event: 'user_click',
                        type: 'synopsis',
                        category: expanded
                          ? 'read_less_click'
                          : 'read_more_click',
                      });
                      this.setState({ expanded: !expanded });
                    }}
                  >
                    {expanded ? 'Read Less' : 'Read More'}
                  </span>
                )}
              </div>
            </div>
          </div>
        </InViewObserver>
      )
    );
  }
}
Synopsis.propTypes = {
  synopsis: PropTypes.string,
};
Synopsis.defaultProps = {
  synopsis: [],
};

export default Synopsis;
